import { Route } from "@angular/router";
import { authGuard, rolesGuard } from "@core/guards";
import { DocumentsPageComponent } from "@pages/documents/components/documents-page/documents-page.component";
import {
  ImportedDocumentPageComponent
} from "../../generate-documents/components/imported-document-page/imported-document-page.component";
import { GenerateDocumentsComponent } from "../../generate-documents/generate-documents.component";

export function getDocumentsRoutes(): Route[] {
  return [
    {
      path: 'documents',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          path: '',
          component: DocumentsPageComponent,
          title: 'Documents',
        },
        {
          path: ':id',
          component: GenerateDocumentsComponent,
          title: 'Generate Documents',
          canActivate: [
            () => rolesGuard(['Admin', 'Manager', 'Preparer'], '/documents')
          ]
        },
      ]
    },
    {
      path: 'imported-document/:id',
      component: ImportedDocumentPageComponent,
      title: ImportedDocumentPageComponent.importedDocumentTitle,
      canActivate: [
        authGuard,
        () => rolesGuard(['Admin', 'Manager', 'Preparer'], '/documents')
      ]
    },
  ];
}
